<template>
    <div class="honor-rules" v-bkloading="{isLoading: initLoading}">
        <section class="banner">
            <img class="medal-bg" src="../images/honor_system/medal.png" alt="">
            <div class="contents">
                <p class="title">蓝鲸社区荣誉勋章</p>
                <p class="desc">勋章是蓝鲸用户在蓝鲸社区进行活跃互动的奖励，是社区参与度的直接体现</p>
            </div>
        </section>
        <!-- 社区荣誉-社区专家 -->
        <section class="honor-wrapper">
            <div class="honor-content">
                <img class="title" src="../images/honor_system/h1-1.png" />
                <ul class="honor-list">
                    <li class="honor-item" v-for="(item, index) in communityHonorList" :key="index">
                        <img v-if="item.is_user_get" class="honor-img" :src="item.icon_on" alt="">
                        <img v-else class="honor-img" :src="item.icon_off" alt="">
                        <p class="honor-time mr-auto">{{ item.name.split('-')[0] }}</p>
                        <p class="honor-title">{{ item.name.split('-')[1] }}</p>
                        <p class="honor-name mr-auto">{{ item.is_user_get ? userInfo.name : '请加油' }}</p>
                        <!-- <p>{{ item.name }}</p> -->
                        <p class="honor-nums">
                            <span style="margin-right: 12px">{{ matchHonor(item.name.split('-')[1]) }}</span>
                            <span>{{ item.total_get_count }} 人已获得</span>
                        </p>
                    </li>
                </ul>
            </div>
        </section>
        <!-- 蓝鲸成长 -->
        <section class="growth-wrapper">
            <div class="growth-content">
                <img class="title" src="../images/honor_system/h1-2.png" />
                <ul class="growth-list">
                    <li
                        class="growth-item"
                        :style="{'marginRight': `${index < 3 ? (179 + 11*index) : 0}px`}"
                        v-for="(info, index) in growthList"
                        :key="index">
                        <img class="medal-icon" :src="(!userInfo.user_id || info.is_user_get) ? info.icon_on: info.icon_off" alt="">
                        <div :class="['milestone', {'active': info.is_user_get}]"></div>
                        <p class="name">{{ info.name }}</p>
                        <p class="desc">{{ info.desc }}</p>
                    </li>
                </ul>
                <div class="growth-progress">
                    <div :class="['bar', {'is-init': isInit}]" :style="{ width: percentage }" @mouseleave="isInit = false">
                        <div
                            v-if="userInfo.user_id && !growthList[3].is_user_get"
                            class="growth-bar-pop">
                            {{ `当前位置，还差 ${remainderDays} 天即可解锁` }}
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 用户身份 -->
        <section class="identity-wrapper">
            <div class="identity-content">
                <img class="title" src="../images/honor_system/h1-3.png" />
                <ul class="identify-list">
                    <li v-for="(info, index) in identifyList" :key="index">
                        <div class="left-medal">
                            <img :src="(!userInfo.user_id || info.is_user_get) ? info.icon_on: info.icon_off" alt="">
                        </div>
                        <div class="right-box">
                            <div class="right-top">
                                <span class="medal-name">{{ info.name }}</span>
                                <span class="have-tasks">{{ info.total_get_count }}人获得</span>
                            </div>
                            <div class="medal-desc">{{ info.desc }}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
        <!-- 鲸彩赛事 -->
        <section class="competition-wrapper">
            <div class="competition-content">
                <img class="title" src="../images/honor_system/h1-4.png" />
                <ul class="competition-list">
                    <li v-for="item in competitionList" :key="item.id">
                        <div class="competition-label">{{ item.name }}</div>
                        <ul class="competition-rank">
                            <li :class="['rank-item', {'is-active': info.is_user_get}]" v-for="info in item.medal" :key="info.id">
                                <img class="medal-icon" :src="(!userInfo.user_id || info.is_user_get) ? info.icon_on: info.icon_off" alt="">
                                <div class="award-years" v-if="info.year">
                                    <span class="date">{{ info.year }}</span>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </section>
        <!-- 鲸华社区 -->
        <section class="community-wrapper">
            <div class="community-content">
                <img class="title" src="../images/honor_system/H1-5.png" />
                <ul class="zone-list">
                    <li v-for="item in communityList" :key="item.id">
                        <div class="zone-label">{{ item.name }}</div>
                        <div v-for="info in item.medal" :key="info.id" class="content-item">
                            <div class="left-medal">
                                <img :src="(!userInfo.user_id || info.is_user_get) ? info.icon_on: info.icon_off" alt="">
                            </div>
                            <div class="right-box">
                                <div class="right-top">
                                    <span class="medal-name">{{ info.name }}</span>
                                    <span class="have-tasks">{{ info.total_get_count + '人获得' }}</span>
                                </div>
                                <div class="medal-desc">{{ info.desc }}</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
    </div>
</template>

<script>
    import tools from '@/js/tools.js'
    export default {
        data () {
            return {
                initLoading: true,
                isInit: true,
                labelList: [
                    {
                        label: '相逢恨晚',
                        desc: '0 < 注册时间 ≤ 1年'
                    }, {
                        label: '最美年纪遇见',
                        desc: '1年 < 注册时间 ≤2年'
                    }, {
                        label: '三冬两夏',
                        desc: '2年 < 注册时间 ≤ 4年'
                    }, {
                        label: '一路同行',
                        desc: '注册时间 ＞ 4年'
                    }
                ],
                honorList: [
                    {
                        is_has: false,
                        nums: 4
                    },
                    {
                        is_has: true,
                        nums: 41
                    },
                    {
                        is_has: false,
                        nums: 4533
                    },
                    {
                        is_has: false,
                        nums: 415
                    },
                ],
                growthList: [],
                percentage: '0%',
                remainderDays: 0,
                identifyList: [],
                competitionList: [],
                communityList: [],
                communityHonorList: []
            }
        },
        computed: {
            userInfo () {
                return this.$store.state.userInfo
            }
        },
        watch: {
            userInfo: {
                handler (val) {
                    if (val.user_id) {
                        const registerDate = val.register_time.split(' ')[0]
                        this.getSchedule(registerDate)
                    }
                },
                immediate: true
            }
        },
        created () {
            const nameList = ['蓝鲸成长', '用户身份', 'SaaS开发挑战赛,开源贡献奖', '问答专区,脚本专区,SaaS专区,开源专区', '社区荣誉']
            const promiseArray = nameList.map(name => {
                return this.getMedalList(name)
            })
            Promise.all(promiseArray).then(value => {
                // 蓝鲸成长
                const growthInfo = value[0].results[0]
                this.growthList = growthInfo.medal
                // 用户身份
                const identifyInfo = value[1].results[0]
                const filterField = ['社区运维专家', '核心用户']
                this.identifyList = identifyInfo.medal.filter(item => !filterField.includes(item.name))
                // 鲸彩赛事
                this.competitionList = value[2].results.map(item => {
                    item.medal.forEach(val => {
                        if (val.is_user_get) {
                            val.year = val.user_get_time.split('-')[0]
                        }
                    })
                    return item
                })
                // 鲸华社区
                this.communityList = value[3].results
                // 社区荣誉
                this.communityHonorList = value[4].results[0].medal
                this.initLoading = false
            })
        },
        methods: {
            getMedalList (name) {
                try {
                    const path = `profile/medal_type/?ordering=index&name=${name}`
                    return axios.get(myUrl + path).then(res => {
                        const resp = res.data.data
                        return resp
                    })
                } catch (error) {
                    this.initLoading = false
                    console.warn(error)
                }
            },
            matchHonor (name) {
                const mapName = {
                    '腾讯蓝鲸智云社区运维专家': '社区运维专家',
                    '蓝鲸行业说特邀讲师': '社区特邀讲师'
                }
                return mapName[name]
            },
            getSchedule (registerDate) {
                let nowDate = new Date()
                nowDate = tools.handleFormat(nowDate)
                // 注册了多少天
                const day = this.daysDistance(nowDate, registerDate)
                // 计算已经注册多少年
                const registerYear = Math.floor(day / 365)
                if (registerYear >= 4) {
                    this.percentage = '100%'
                    return
                }
                // 计算到下阶段还剩多少天
                const remainderDays = (registerYear + (registerYear === 2 ? 2 : 1)) * 365 - day
                this.remainderDays = remainderDays
                /**
                 * 四个进程点所占的宽百分比度
                 * 112 大于四年后的进度长度
                 * 1120 进程条总长度
                 */
                const growthWidth = 1 - 112 / 1120
                let percentage = 0
                if (registerYear >= 2) {
                    percentage = ((2/3 + ((day - 730) / 730)/3) * growthWidth * 100).toFixed(2) || 0
                } else {
                    percentage = (((day / 730) * (2/3)) * growthWidth * 100).toFixed(2) || 0
                }
                this.percentage = `${percentage}%`
            },
            daysDistance (date1, date2) {
                date1 = Date.parse(date1)
                date2 = Date.parse(date2)
                const distance = Math.abs(date2 - date1)
                const days = Math.floor(distance / (24 * 3600 * 1000))
                return days
            }
        }
    }
</script>

<style lang="scss" scoped>
    @font-face{
        font-family: 'TencentSansW7';
        src : url('../fonts/TencentSansW7.otf');
    }
    .honor-rules {
        background: #fff;
        margin: 60px auto 0;
        font-family: PingFang SC, Microsoft YaHei, AppleSystemUIFont, sans-serif !important;
        .banner {
            position: relative;
            height: 280px;
            padding-top: 13px;
            text-align: center;
            background: url('../images/honor_system/rule-bg.png');
            background-size: cover;
            .medal-bg {
                height: 224px;
                width: 509px;
                margin-left: 68px;
            }
            .contents {
                position: absolute;
                top: 138px;
                left: 0;
                right: 0;
                margin: 0 auto;
                .title {
                    font-size: 46px;
                    color: #313238;
                    line-height: 69px;
                    margin-bottom: 17px;
                    font-family: TencentSansW7, TencentSansW7-Regular;
                }
                .desc {
                    font-size: 16px;
                    color: #63656e;
                    line-height: 18px;
                    font-family: AppleSystemUIFont, AppleSystemUIFont-Regular;
                }
            }
        }
        .honor-wrapper {
            position: relative;
            min-height: 500px;
            text-align: center;
            background: #fafbfd;
            .honor-content {
                width: 1200px;
                margin: 0 auto;
                padding-bottom: 34px;
                .title {
                    display: block;
                    width: 198px;
                    height: 211px;
                    margin: 2px auto 28px;
                }
                .honor-list {
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    .honor-item {
                        width: 282px;
                        height: 250px;
                        padding: 31px 74px 30px 71px;
                        margin-bottom: 24px;
                        position: relative;
                        display: flex;
                        overflow: hidden;
                        flex-direction: column;
                        align-items: center;
                        .honor-img {
                            position: absolute;
                            top: 31px;
                            left: 71px;
                            width: 137px;
                            height: 160px;
                            margin-bottom: 7px;
                        }
                        .mr-auto {
                            margin: 0 auto;
                            position: relative;
                            color: #ffffff;
                        }
                        .honor-nums {
                            display: inline-block;
                            position: absolute;
                            bottom: 26px;
                            margin-top: 75px;
                            padding: 0 24px;
                            height: 22px;
                            line-height: 22px;
                            font-size: 12px;
                            background: #eaebf0;
                            border-radius: 2px;
                        }
                        .honor-time {
                            margin: 32px auto 0px;
                            font-size: 10px;
                            font-family: TencentSansW3;
                        }
                        .honor-title {
                            width: 282px;
                            display: inline-block;
                            color: #fff;
                            height: 10px;
                            transform: scale(0.5);
                            font-size: 14px;
                            font-family: TencentSansW7;
                        }
                        .honor-name {
                            height: 21px;
                            font-size: 14px;
                            margin-top: 11px;
                            font-family: TencentSansW7;
                        }
                    }
                }
            }
        }
        .growth-wrapper {
            position: relative;
            height: 500px;
            text-align: center;
            background: #fff;
            .growth-content {
                width: 1200px;
                margin: 0 auto;
            }
            .title {
                display: block;
                width: 198px;
                height: 211px;
                margin: 2px auto 28px;
            }
            .growth-list {
                display: flex;
                align-items: center;
                height: 160px;
                .growth-item {
                    text-align: center;
                    .medal-icon {
                        display: inline-block;
                        height: 70px;
                        width: 70px;
                        margin-bottom: 16px;
                    }
                    .milestone {
                        position: relative;
                        z-index: 3;
                        width: 24px;
                        height: 24px;
                        background: #ffffff;
                        border: 3px solid #c4c6cc;
                        border-radius: 50%;
                        margin: 0 auto 18px;
                        &.active {
                            border: 4px solid #ffb848;
                        }
                    }
                    .name {
                        text-align: center;
                        font-size: 16px;
                        color: #313238;
                        line-height: 22px;
                        margin-bottom: 4px;
                        font-weight: 600;
                        padding: 0;
                        font-family: PingFangSC, PingFangSC-Semibold;
                    }
                    .desc {
                        color: #63656e;
                        line-height: 20px;
                        font-family: PingFangSC, PingFangSC-Regular;
                    }
                    &:first-child {
                        padding-left: 15px;
                        text-align: left;
                        .medal-icon {
                            margin-left: 10px;
                        }
                        .milestone {
                            margin-left: 27px;
                        }
                        .name {
                            text-align: left;
                            padding-left: 12px;
                        }
                    }
                    &:nth-child(2) {
                        margin-right: 265px;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
            .growth-progress {
                position: relative;
                top: -77px;
                margin-left: 42px;
                width: 1110px;
                height: 16px;
                background: #eaebf0;
                border-radius: 21px;
                margin-bottom: 18px;
                .bar {
                    position: relative;
                    top: 0;
                    left: 0;
                    z-index: 2;
                    height: 100%;
                    width: 0%;
                    max-width: 100%;
                    transition: all .5s;
                    border-radius: 21px;
                    background: linear-gradient(90deg,#fde9a5 6%, #ffb120 100%);
                    .growth-bar-pop {
                        display: none;
                        position: absolute;
                        top: -45px;
                        right: -74px;
                        width: 188px;
                        height: 32px;
                        text-align: center;
                        line-height: 32px;
                        background: #ffb848;
                        border-radius: 4px;
                        color: #fff;
                        font-size: 12px;
                        font-family: PingFangSC, PingFangSC-Regular;
                        transition: all .5s;
                        &::after {
                            content: '';
                            position: absolute;
                            left: 50%;
                            bottom: -8px;
                            border-width: 10px 7.5px 0;
                            border-style: solid;
                            border-color: #ffb848 transparent transparent;
                        }
                    }
                    &:hover, &.is-init {
                        .growth-bar-pop {
                            display: block;
                        }
                    }
                }
            }
        }
        .identity-wrapper {
            background: #fafbfd;
            .identity-content {
                width: 1200px;
                margin: 0 auto;
                padding-bottom: 34px;
            }
            .title {
                display: block;
                width: 198px;
                height: 211px;
                margin: 0 auto 30px;
            }
            .identify-list {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                > li {
                    width: 592px;
                    height: 114px;
                    display: flex;
                    padding: 25px 24px 0;
                    margin-bottom: 16px;
                    background: #ffffff;
                    border-radius: 4px 0px 0px 0px;
                    box-shadow: 0px 2px 4px 0px rgba(25,25,41,0.05);
                    .left-medal {
                        height: 64px;
                        width: 64px;
                        margin-right: 12px;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .right-box {
                        padding-top: 6px;
                        .right-top {
                            display: flex;
                            align-items: center;
                            margin-bottom: 9px;
                            .medal-name {
                                font-size: 18px;
                                color: #313238;
                                font-weight: 700;
                                line-height: 25px;
                                margin-right: 12px;
                            }
                            .have-tasks {
                                padding: 2px 5px 3px 8px;
                                font-size: 12px;
                                color: #63656e;
                                line-height: 15px;
                                font-family: AppleSystemUIFont, AppleSystemUIFont-Regular;
                                background: #f0f1f5;
                                border-radius: 10px;
                            }
                        }
                        .medal-desc {
                            color: #63656e;
                            text-align: left;
                            line-height: 17px;
                            font-family: AppleSystemUIFont, AppleSystemUIFont-Regular;
                        }

                    }
                }
            }
        }
        .competition-wrapper {
            background: url('../images/honor_system/competition-bg.png') center center;
            background-size: cover;
            .competition-content {
                width: 1200px;
                margin: 0 auto;
                padding-top: 10px;
            }
            .title {
                display: block;
                width: 198px;
                height: 211px;
                margin: 0 auto 53px;
            }
            .competition-list {
                padding-left: 12px;
                padding-bottom: 53px;
                > li {
                    position: relative;
                    margin-bottom: 103px;
                    .competition-label {
                        position: absolute;
                        top: -63px;
                        left: -12px;
                        z-index: 2;
                        width: 224px;
                        height: 42px;
                        font-size: 20px;
                        line-height: 28px;
                        color: #fff;
                        padding: 7px 0 0 24px;
                        background: linear-gradient(167deg,#ffdd68 4%, #ffba3b 100%);
                        font-family: PingFangSC, PingFangSC-Medium;
                        &::after {
                            content: '';
                            position: absolute;
                            top: 0;
                            right: 0;
                            border-width: 0 24px 42px 0;
                            border-color: transparent #fff6de;
                            border-style: solid;
                        }
                    }
                    .competition-rank {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                    }
                    .rank-item {
                        position: relative;
                        height: 200px;
                        width: 285px;
                        text-align: center;
                        background: #fff;
                        border-radius: 25px 25px 40px 40px;
                        margin: 0 16px 20px 0;
                        padding-top: 31px;
                        background: url('../images/honor_system/rank_bg.png');
                        background-size: cover;
                        .medal-icon {
                            display: inline-block;
                            width: 130px;
                            height: 130px;
                        }
                        .award-years {
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 74px;
                            height: 64px;
                            background: url('../images/honor_system/subscript-bg.png');
                            background-size: 100% 100%;
                            .date {
                                position: absolute;
                                right: 3px;
                                top: 10px;
                                display: inline-block;
                                font-size: 16px;
                                color: #ffffff;
                                line-height: 25px;
                                font-family: HelveticaNeue, HelveticaNeue-Bold;
                                font-weight: 700;
                                transform: rotate(40deg);
                            }
                        }
                        &:nth-child(4n) {
                            margin-right: 0;
                        }
                    }
                    &::before {
                        content: '';
                        position: absolute;
                        bottom: 0px;
                        top: -22px;
                        left: 0;
                        z-index: 1;
                        height: 2px;
                        width: 1200px;
                        background: #f8e8c6;
                    }
                    &:last-child {
                        margin-bottom: 0;
                        .competition-label {
                            width: 180px;
                        }
                    }
                }
            }
        }
        .community-wrapper {
            background: #fafbfd;
            .community-content {
                width: 1200px;
                margin: 0 auto;
                padding-bottom: 32px;
            }
            .title {
                display: block;
                width: 198px;
                height: 211px;
                margin: 0 auto 30px;
            }
            .zone-list {
                 > li {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    position: relative;
                    margin-bottom: 93px;
                    .zone-label {
                        position: absolute;
                        top: -59px;
                        z-index: 2;
                        width: 150px;
                        height: 42px;
                        font-size: 20px;
                        line-height: 28px;
                        color: #fff;
                        padding: 7px 0 0 24px;
                        background: linear-gradient(167deg,#ffdd68 4%, #ffba3b 100%);
                        font-family: PingFangSC, PingFangSC-Medium;
                        &::after {
                            content: '';
                            position: absolute;
                            top: 0;
                            right: 0;
                            border-width: 0 24px 42px 0;
                            border-color: transparent #fafbfd;
                            border-style: solid;
                        }
                    }
                    .content-item {
                        width: 592px;
                        height: 114px;
                        display: flex;
                        padding: 25px 24px 0;
                        margin-bottom: 16px;
                        background: #ffffff;
                        border-radius: 4px 0px 0px 0px;
                        box-shadow: 0px 2px 4px 0px rgba(25,25,41,0.05);
                        .left-medal {
                            height: 64px;
                            width: 64px;
                            margin-right: 12px;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .right-box {
                            padding-top: 6px;
                            .right-top {
                                display: flex;
                                align-items: center;
                                margin-bottom: 9px;
                                .medal-name {
                                    font-size: 18px;
                                    color: #313238;
                                    font-weight: 700;
                                    line-height: 25px;
                                    margin-right: 12px;
                                }
                                .have-tasks {
                                    padding: 2px 5px 3px 8px;
                                    font-size: 12px;
                                    color: #63656e;
                                    line-height: 15px;
                                    font-family: AppleSystemUIFont, AppleSystemUIFont-Regular;
                                    background: #f0f1f5;
                                    border-radius: 10px;
                                }
                            }
                            .medal-desc {
                                color: #63656e;
                                text-align: left;
                                line-height: 17px;
                                font-family: AppleSystemUIFont, AppleSystemUIFont-Regular;
                            }

                        }
                    }
                    &::before {
                        content: '';
                        position: absolute;
                        bottom: 0px;
                        top: -18px;
                        left: 0;
                        z-index: 1;
                        height: 2px;
                        width: 1200px;
                        background: #f8e8c6;
                    }
                    &:first-child, &:nth-child(2) {
                        .zone-label {
                            width: 144px;
                        }
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// honorRules.vue?2abcbd10